import {createSlice} from  '@reduxjs/toolkit';

const initialState = {
    isloading:false,
    status:"",
    message:"",
};

const userDeleteSlice = createSlice({
    name:"userDelete",
    initialState,
    reducers:{
        deletePending: (state,action) =>{
            state.isloading=true;
        },
        deleteSuccess: (state,{payload}) =>{
            state.isloading=false;
            state.status="success";
            state.message="user deleted successfully";
        },
        deleteFail: (state,{payload}) =>{
            state.isloading=false;
            state.status="error";
            state.message=payload.message;
        },
    }
});


const {reducer, actions} = userDeleteSlice;
export const {deletePending,deleteSuccess,deleteFail} =actions;
export default reducer;
